// extracted by mini-css-extract-plugin
module.exports = {"cta":"SectionCta_cta__27wN1"};